import type { EventInterceptorProps } from '@consta/uikit/EventInterceptor'
import { selectPreferredName, useAppSelector } from '@core/core/store'
import type { SpaCustomParam } from '@core/core/types'
import { sendSpaConstaEvent } from '@core/core/utils'
import { isObject } from 'common/helpers'
import { useCallback } from 'react'

/**
 * Обработчик для посылки в СПА от констовских компонентов
 */
export const useSpaEventHandler = () => {
  const login = useAppSelector(selectPreferredName)

  return useCallback(
    (props: EventInterceptorProps) => {
      if (!login) return

      const eventProps: unknown = props.options.props
      if (isObject(eventProps)) {
        let customParams: SpaCustomParam[] | string = []
        if (
          'data-analytic-params' in eventProps &&
          Array.isArray(eventProps['data-analytic-params'])
        ) {
          customParams = eventProps['data-analytic-params']
        }

        const userIdParams = [
          { name: 'user_id', value: login, type: 'STRING' },
          { as_user_id: true, value: login },
        ]

        const encodedCustomParams = encodeURIComponent(
          JSON.stringify([...customParams, ...userIdParams]),
        )
        Object.defineProperty(eventProps, 'data-analytic-params', {
          value: encodedCustomParams,
          writable: true,
          enumerable: true,
          configurable: true,
        })
        sendSpaConstaEvent(props)
      }
    },
    [login],
  )
}
